import { Card, CardContent, CardHeader } from '@/components/ui/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import React, { useEffect, useState } from 'react';
import { MaterialIcon } from '@/components/ui/shared/materialIcon';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const basePath = '/userAccount/';

// Full admin menu set
const fullAdminMenu = [
  {
    label: 'Popup lango parametrai',
    icon: 'settings_applications',
    link: `${basePath}popup`,
    roles: ['popupadmin', 'affidea'],
  },
  {
    label: 'Gydytojų informacija',
    icon: 'info',
    link: `${basePath}doctorInformation`,
    roles: ['popupadmin', 'affidea'],
  },
  {
    label: 'Paslaugų informacija',
    icon: 'medical_services',
    link: `${basePath}serviceInformation`,
    roles: ['popupadmin', 'affidea'],
  },
  {
    label: 'Padalinių nustatymai',
    icon: 'local_hospital',
    link: `${basePath}admin/departments`,
    roles: ['popupadmin', 'affidea'],
  },
  {
    label: 'Vaikų gydytojų nustatymai',
    icon: 'child_care',
    link: `${basePath}admin/restrictions`,
    roles: ['popupadmin', 'affidea'],
  },
  {
    label: 'Papildomų paslaugų nustatymai',
    icon: 'storage',
    link: `${basePath}customservices`,
    roles: ['popupadmin', 'affidea'],
  },
  {
    label: 'Populiarių paieškų pavadinimai',
    icon: 'search',
    link: `${basePath}popularSearchTitleMapping`,
    roles: ['popupadmin', 'affidea'],
  },
  {
    label: '"Tapk pacientu" informacija',
    icon: 'person_add',
    link: `${basePath}patientInfo`,
    roles: ['affidea'],
  },
  {
    label: 'AMIS kreipinių žurnalas',
    icon: 'history',
    link: `${basePath}logs`,
    roles: ['affidea'],
  },
  {
    label: 'AMIS sinchronizacija',
    icon: 'sync',
    link: `${basePath}sync`,
    roles: ['affidea'],
  },
  {
    label: 'Įvykių žurnalas',
    icon: 'event_note',
    link: `${basePath}syncLogs`,
    roles: ['affidea'],
  },
  {
    label: 'Sutikimų pakeitimai',
    icon: 'fact_check',
    link: `${basePath}consentLogs`,
    roles: ['affidea'],
  },
  {
    label: 'Amis užklausų klaidos',
    icon: 'error_outline',
    link: `${basePath}amis/requests`,
    roles: ['affidea'],
  },
];

const UserAccountAdminSidebar = ({ role = '', currentStep }) => {
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 640);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const filteredMenu = fullAdminMenu.filter((item) =>
    item.roles.includes(role.toLowerCase()),
  );

  const renderSidebarItems = () => (
    <>
      {filteredMenu.map((item, i) => (
        <SidebarItem
          key={i}
          icon={item.icon}
          label={item.label}
          link={item.link}
          active={currentStep === item.label}
        />
      ))}
    </>
  );

  return (
    <Card className="w-full my-4 sm:my-0">
      {!isMobile && (
        <CardHeader>
          <div className="text-sm/6 font-normal text-affidea-gray">
            Administravimas
          </div>
        </CardHeader>
      )}

      {isMobile ? (
        <Collapsible open={expanded} onOpenChange={setExpanded}>
          <CollapsibleTrigger asChild>
            <div className="flex items-center justify-between w-full h-12 cursor-pointer px-4">
              <span className="flex items-center space-x-2 text-base/6 font-semibold text-primary">
                <MaterialIcon icon="menu" size={24} />
                <span>Administravimas</span>
              </span>
              {expanded ? (
                <ChevronUp size={20} className="text-[#5180CA]" />
              ) : (
                <ChevronDown size={20} className="text-[#5180CA]" />
              )}
            </div>
          </CollapsibleTrigger>
          <CollapsibleContent>
            <CardContent className="pb-4 pt-2">
              {renderSidebarItems()}
            </CardContent>
          </CollapsibleContent>
        </Collapsible>
      ) : (
        <CardContent className="sm:pb-4">{renderSidebarItems()}</CardContent>
      )}
    </Card>
  );
};

const SidebarItem = ({ icon, label, link = '#' }) => {
  const location = useLocation();

  const normalize = (path) => path.replace(/\/+$/, '').toLowerCase();
  const currentPath = normalize(location.pathname);
  const targetPath = normalize(link);

  const isUnderUserAccount = link
    .toLocaleLowerCase()
    .startsWith(basePath.toLocaleLowerCase());
  const isActive =
    isUnderUserAccount &&
    (currentPath === targetPath || currentPath.startsWith(targetPath + '/'));

  return (
    <a
      href={link}
      className={`flex items-center space-x-2 w-full min-h-12 text-base/6 px-0 ${
        isActive ? 'text-primary font-semibold bg-background px-2' : ''
      }`}
    >
      <MaterialIcon icon={icon} size={24} />
      <span>{label}</span>
    </a>
  );
};

export default UserAccountAdminSidebar;
